import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/sidebar.css';
import picklLogo from '../../images/pickl_logo_white.png';

const Sidebar = ({ user }) => {
  const [isActive, setIsActive] = useState(false);
  const [cachedUser, setCachedUser] = useState(null);

  useEffect(() => {
    // Hydrate from localStorage to avoid badge flicker during navigation
    try {
      const cached = window.localStorage.getItem('picklUser');
      if (cached) {
        setCachedUser(JSON.parse(cached));
      }
    } catch (e) {}
  }, []);

  const effectiveUser = user || cachedUser;

  const toggleSidebar = () => {
    console.log('HAMBURGER BUTTON CLICKED!');
    console.log('Toggle clicked, current state:', isActive);
    setIsActive(!isActive);
    console.log('After toggle, new state:', !isActive);
  };

  // Handle sidebar state on resize
  useEffect(() => {
    const handleResize = () => {
      const isDesktop = window.innerWidth >= 884;
      const isMobile = window.innerWidth <= 883;
      
      // If resizing down to mobile/tablet and sidebar is open, close it
      if (isMobile && isActive) {
        setIsActive(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isActive]);

  return (
    <div id="sidebar" className={isActive ? 'active' : ''}>
      <div className="toggle-btn" onClick={toggleSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="list">
        <div className="item item-logo">
          <Link to="/landing" className="logo-link" aria-label="Go to landing">
            <img src={picklLogo} className="logo" alt="Pickl" />
            <span className="badge badge-pill">Beta</span>
          </Link>
        </div>
        <hr className="" />
        <div className="item">
          <Link to="/">
            <i className="fa-solid fa-film" style={{ margin: '0px 10px 0px 0px' }}></i> Recommendations
          </Link>
        </div>
        <div className="item">
          <Link to="/favorites">
            <i className="fa-solid fa-heart" style={{ margin: '0px 10px 0px 0px' }}></i> My Watchlist
          </Link>
        </div>
        <div className="item">
          <Link to="/watched">
            <i className="fa-solid fa-eye" style={{ margin: '0px 9px 0px 0px' }}></i> Already Watched
          </Link>
        </div>
        <div className="item item-with-badge">
          <Link to="/groups">
            <i className="fa-solid fa-screen-users" style={{ margin: '0px 7px 0px 0px' }}></i> My Groups
            {effectiveUser?.new_invites > 0 && (
              <span className="badge badge-pill badge-warning" style={{ marginLeft: '8px' }}>
                <i className="fa-light fa-envelope"></i>&nbsp;{effectiveUser.new_invites}
              </span>
            )}
          </Link>
        </div>
        <hr className="" />
      </div>

      <div className="list position-bottom">
        <div className="item">
          <Link to="/user-settings">
            <i className="fa-solid fa-user-gear" style={{ margin: '0px 10px 0px 0px' }}></i>User Settings
          </Link>
        </div>
        <div className="item">
          <a href="/logout/">
            <i className="fa-solid fa-right-from-bracket" style={{ margin: '0px 10px 0px 0px' }}></i> Sign Out
          </a>
        </div>
        <div className="item" style={{ fontSize: '0.8em', color: '#ddd' }}>
          <div>&copy; Pickl. All rights reserved.</div>
          <div>
            <a href="/tos/">Terms of Service</a><br />
            <a href="/privacy/">Privacy Policy</a>
          </div>
        </div>
      </div>
    </div>
  );
};


export default Sidebar; 

